/* HEWI — Swym wishlist copy overrides (Claude, 2026-06-12)
   Swym's drawer strings come from its remote config; the drawer renders as plain
   DOM in our page, so we rewrite the visible text here. Copy rules: no exclamation
   marks, no "stuff", no authentication claims. */
(function () {
  var SWAPS = [
    ["Your collections are to stay here forever!", "Keep your wishlist"],
    ["Login to save your stuff for good and access them whenever, wherever!", "Sign in to keep your saved pieces across devices."],
    ["Login to Save", "Sign in"],
    ["This is an empty list!", "Nothing saved yet"],
    ["Continue Shopping", "Continue shopping"],
    ["My Wishlist", "Wishlist"],
    ["Guest Shopper", "Your wishlist"]
  ];

  function swapIn(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var t = node.nodeValue;
      if (!t || t.length < 4) continue;
      for (var i = 0; i < SWAPS.length; i++) {
        if (t.indexOf(SWAPS[i][0]) !== -1) {
          node.nodeValue = t.replace(SWAPS[i][0], SWAPS[i][1]);
        }
      }
    }
  }

  function containers() {
    return document.querySelectorAll(
      "swym-storefront-layout, .swym-wishlist-modal-container, #swym-consent-popup"
    );
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      containers().forEach(function (c) { swapIn(c); });
    });
  }

  function start() {
    schedule();
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var n = muts[i].target;
        if (n && n.nodeType === 1 && n.closest &&
            n.closest("swym-storefront-layout, .swym-wishlist-modal-container, #swym-consent-popup, .shopify-app-block")) {
          schedule();
          return;
        }
        if (n && n.nodeType === 3) { schedule(); return; }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
